<div id="container">
  <div id="control-row">
    <button [disabled]="!entityId" mat-raised-button color="primary" (click)="addNewDocument()">Új dokumentum</button>
    <app-document-select
      [selectControl]="documentTypeFilter"
      [addEmptyElement]="true"
      [documentTypes]="documentTypes"
    ></app-document-select>
  </div>

  @for (doc of newDocuments; track trackByItem($index, doc)) {
    <div class="new-document-entry">
      <app-document-entry
        [newEventId]="doc.newDocId"
        [errorMessage]="doc.errorMessage"
        [percentChange]="doc.percentChange"
        [documentTypes]="documentTypes"
        (upload)="upload($event)"
        (delete)="delete($event)"
      ></app-document-entry>
    </div>
  }

  <mat-divider></mat-divider>

  @for (doc of filteredDocuments; track doc) {
    <div class="document-entry">
      <app-document-entry
        [document]="doc"
        (delete)="delete($event)"
        (renew)="renew($event)"
        (sendEmail)="sendEmail($event)"
        [documentTypes]="documentTypes"
      ></app-document-entry>
    </div>
  }
</div>
